const errorMessages = {
  errorMessage: "To polje je obvezno",
  errorEmail: "Vstavite veljaveno e-pošto",
};

export default errorMessages;
